import { render } from "./CookiesImageInput.vue?vue&type=template&id=5575d8e8&scoped=true&ts=true"
import script from "./CookiesImageInput.vue?vue&type=script&lang=ts"
export * from "./CookiesImageInput.vue?vue&type=script&lang=ts"

import "./CookiesImageInput.vue?vue&type=style&index=0&id=5575d8e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5575d8e8"]])

export default __exports__